import { ColorCardStore } from "src/components/ColorCard/ColorCardStore";
import { z } from "zod";

export const zAttrColorCard = z.object({
  editor: z.literal("ColorCard"),
  height: z.number().nullable().optional(),
  addonBefore: z.string().nullable().optional(),
  addonAfter: z.string().nullable().optional(),
});
export type ZAttrColorCard = z.infer<typeof zAttrColorCard>;

export const makeAttrColorCardProps = (src: ZAttrColorCard) => ({
  store: new ColorCardStore(),
  height: src.height ?? undefined,
  addonBefore: src.addonBefore ?? undefined,
  addonAfter: src.addonAfter ?? undefined,
});
